module.exports = __webpack_public_path__ + "static/img/product_screen.f77c700.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/product_screen.jpg
// module id = BHr1
// module chunks = 0